export default {"src":"/_next/static/media/logo-m-mwk_de.73354045.svg","height":42,"width":277,"blurWidth":0,"blurHeight":0};